import { CreditPayload, IResponse, consumer, postFile } from "@bemap/utils"
import { ITeam } from "@bemap/utils"

export const getAnalysts = async (): Promise<IResponse> => {
  let url = `/analysts`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const getAnalystById = async (id: number): Promise<IResponse> => {
  let url = `/analysts/${id}`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const getAnalystDashboard = async (startDate?: string, endDate?: string): Promise<IResponse> => {
  let url = `/reports/analyst-dashboard`

  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}`
  }

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const getCreditHistory = async (id: number): Promise<IResponse> => {
  let url = `/credits/${id}/history`

  try {
    return await consumer('GET', url)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    return {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function newAnalyst(payload: ITeam): Promise<IResponse> {
  // dados da requisição
  const url = `/analysts`

  // request
  try {
    return await consumer('POST', url, payload);

  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export const updateAnalyst = async (payload: ITeam): Promise<IResponse> => {
  // dados da requisição
  const url = `/analysts/${payload.id}`

  // request
  try {
    return await consumer('PATCH', url, {
      name: payload.name,
      email: payload.user?.email,
      phone: payload.user?.phone,
      isPremium: payload.isPremium,
    });
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function deleteAnalyst(id: number): Promise<IResponse> {
  // dados da requisição
  const url = `/analysts/${id}`

  // request
  try {
    return await consumer('DELETE', url);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function toggleStatus(active: boolean, TeamId: string): Promise<IResponse> {
  // dados da requisição
  const url = `/teams/${TeamId}`
  const body = {
    status: active ? 1 : 0,
  };

  // request
  try {
    return await consumer('PATCH', url, body);
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
}

export async function batchAnalysts(payload: FormData): Promise<IResponse> {
  const url = `/analysts/batch`
  return await postFile(url, payload);
}

export async function handleCredit(payload: CreditPayload, router: string): Promise<IResponse> {
  // dados da requisição
  const url = `/credits/${router}`

  // request
  try {
    return await consumer('POST', url, payload)
  } catch (error: any) {
    const msg = error.response?.data?.message || 'An error occurred';
    throw {
      statusCode: error.response?.status || 500,
      message: msg
    }
  }
} 